import React from 'react';

const EmptyState = ({
  icon,
  title,
  message,
  eyebrow,
  actions,
  compact = false,
  className = '',
  testId
}) => {
  const classes = [
    'card border-0 shadow-sm empty-state',
    compact ? 'empty-state--compact' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} data-testid={testId}>
      <div className="card-body empty-state__body text-center">
        <div className="empty-state__icon" aria-hidden="true">
          <i className={`bi bi-${icon}`}></i>
        </div>
        {eyebrow ? <div className="empty-state__eyebrow">{eyebrow}</div> : null}
        <h2 className="empty-state__title">{title}</h2>
        <p className="empty-state__message">{message}</p>
        {actions ? <div className="empty-state__actions">{actions}</div> : null}
      </div>
    </div>
  );
};

export default EmptyState;